import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { UuidInspectorPage } from "@/tools/uuid-inspector/pages/UuidInspectorPage";

const PATH = "/uuid-inspector";

export const Route = createFileRoute("/uuid-inspector")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.ud_meta_title() },
      { name: "description", content: m.ud_meta_description() },
      { property: "og:title", content: m.ud_meta_title() },
      { property: "og:description", content: m.ud_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.ud_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.ud_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: m.ud_faq1_q(),
              acceptedAnswer: { "@type": "Answer", text: m.ud_faq1_a() },
            },
            {
              "@type": "Question",
              name: m.ud_faq2_q(),
              acceptedAnswer: { "@type": "Answer", text: m.ud_faq2_a() },
            },
            {
              "@type": "Question",
              name: m.ud_faq3_q(),
              acceptedAnswer: { "@type": "Answer", text: m.ud_faq3_a() },
            },
            {
              "@type": "Question",
              name: m.ud_faq4_q(),
              acceptedAnswer: { "@type": "Answer", text: m.ud_faq4_a() },
            },
          ],
        }),
      },
    ],
  }),
  component: UuidInspectorPage,
});
